module.exports = __webpack_public_path__ + "static/img/safari.b840913a.png";